import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { otpValidation } from 'src/app/models/otpValidation.model';
import { AdobeAnalyticsService } from 'src/app/services/adobe-analytics.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { ProductService } from 'src/app/services/product.service';
import { SubjectService } from 'src/app/services/subject.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
  selector: 'app-verification-login',
  templateUrl: './verification-login.component.html',
  styleUrls: ['./verification-login.component.scss'],
})
export class VerificationLoginComponent implements OnInit {
  otp: string = '';
  otpVerificationScreen: boolean = false;
  otpValidationModel: otpValidation = new otpValidation();
  mobileNumber: any = '';
  maskedAccountNo: string = '';
  config = {
    allowNumbersOnly: true,
    length: 6,
    // isPasswordInput: true,
    disableAutoFocus: false,
    placeholder: '●',
    inputStyles: {
      width: '50px',
      height: '50px',
    },
  };
  showSubscriptionTemplate: boolean = false;
  showSuccessTemplate: boolean = false;
  sku: any;
  additionalBenefits: any;
  howtoSubscribe: any;
  termsCondition: any;
  currentAccount: any;
  showOTP: boolean = false;
  main: any;
  constructor(
    private modalController: ModalController,
    private productService: ProductService,
    private UTS: UtilitiesService,
    private SS: SubjectService,
    private GAS: GoogleAnalyticsService,
    private AAS: AdobeAnalyticsService
  ) {
  
  }
  ngDestory() {
    this.showSubscriptionTemplate = false;
    this.showSuccessTemplate = false;
    this.showOTP = false;
    this.SS.addonBuySuccessfully.unsubscribe();
  }

  ngAfterContentInit(){
    this.SS.currentAccount.subscribe((r) => {
      this.currentAccount = r;
      this.mobileNumber = this.currentAccount.accountNo;
    });
    this.SS.subscribeLogin.subscribe((r) => {
      if(r == true){
        this.showOTP = true;
      }
    });
  }
  async ngOnInit() {
   
  }


  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true,
    });
  }

  getOTP() {
    this.productService
      .getMobileEligibility(this.mobileNumber)
      .subscribe((resp) => {
        if (resp.status == 1) {
          this.productService
            .generateOTP(this.mobileNumber)
            .subscribe((resp) => {
              this.maskedAccountNo = resp.maskedAccountNo;
              this.otpVerificationScreen = true;
            });
        }
      });
  }

  changeOTP(otp: string) {
    this.otp = otp;
  }

  validateOtp() {
    this.otpValidationModel.accountNo = this.mobileNumber;
    this.otpValidationModel.authValue = this.otp;
    this.otpValidationModel.authType = 'otp';
    this.productService
      .validateOTP(this.otpValidationModel)
      .subscribe((resp) => {
        //   if(resp.success) this.route.navigate(['/success'])
        this.SS.account.next(this.mobileNumber);
        if (resp.success) {
          this.GAS.OTPVerification(this.main.name,'Submit')
          this.AAS.OTPVerification(this.main.name,'Submit')
          this.showSubscriptionTemplate = true;
        }
        else{
          this.GAS.OTPVerification(this.main.name,'Error')
          this.AAS.OTPVerification(this.main.name,'Error')
        }
      });
  }
}
